import React from 'react';
import '../../css/BoardView.css';

const PRIORITY_LABELS = {
    NONE: null,
    LOW: { label: 'Low', className: 'low' },
    MEDIUM: { label: 'Medium', className: 'medium' },
    HIGH: { label: 'High', className: 'high' },
    URGENT: { label: 'Urgent', className: 'urgent' },
};

const TASK_TYPE_DISPLAY = {
    EPIC: { label: 'Epic', className: 'epic' },
    STORY: { label: 'Story', className: 'story' },
    TASK: null,
};

const TaskCard = ({ task, boardAbbreviation, onClick, onDragStart, onDragEnd, onContextMenu }) => {
    const priority = PRIORITY_LABELS[task.priority];
    const taskTypeDisplay = TASK_TYPE_DISPLAY[task.task_type];

    const isOverdue = task.due_date && new Date(task.due_date) < new Date();

    const boardTaskId = task.board_task_id || (
        boardAbbreviation
            ? `${boardAbbreviation}-${task.board_number || task.id}`
            : `#${task.board_number || task.id}`
    );

    const formatDueDate = (dateStr) => {
        const date = new Date(dateStr);
        const now = new Date();
        const diffDays = Math.ceil((date - now) / (1000 * 60 * 60 * 24));

        if (diffDays === 0) return 'Today';
        if (diffDays === 1) return 'Tomorrow';
        if (diffDays === -1) return 'Yesterday';
        return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    };

    return (
        <div
            className="TaskCard"
            onClick={onClick}
            draggable
            onDragStart={onDragStart}
            onDragEnd={onDragEnd}
            onContextMenu={onContextMenu}
        >
            {task.labels && task.labels.length > 0 && (
                <div className="TaskCard__labels">
                    {task.labels.map((label, i) => (
                        <span key={i} className="TaskCard__label">{label}</span>
                    ))}
                </div>
            )}

            <div className="TaskCard__id-row">
                {taskTypeDisplay && (
                    <span className={`TaskCard__type-badge TaskCard__type-badge--${taskTypeDisplay.className}`}>
                        {taskTypeDisplay.label}
                    </span>
                )}
                <span className="TaskCard__board-id">{boardTaskId}</span>
                <span className="TaskCard__id">#{task.id}</span>
            </div>

            <h4 className="TaskCard__title">{task.title}</h4>

            {(task.description || task.is_watching || task.comments_count > 0 || task.attachments_count > 0 || priority || task.due_date || task.assignee_info) && (
                <div className="TaskCard__meta">
                    {task.description && (
                        <span className="TaskCard__icon-indicator" title="Has description">
                            <i className="fas fa-align-left" />
                        </span>
                    )}
                    {task.is_watching && (
                        <span className="TaskCard__icon-indicator TaskCard__icon-indicator--watching" title="Watching">
                            <i className="fas fa-eye" />
                        </span>
                    )}
                    {task.comments_count > 0 && (
                        <span className="TaskCard__icon-indicator TaskCard__icon-indicator--comments" title={`${task.comments_count} comment${task.comments_count !== 1 ? 's' : ''}`}>
                            <i className="fas fa-comment" />
                            <span className="TaskCard__icon-indicator-count">{task.comments_count}</span>
                        </span>
                    )}
                    {task.attachments_count > 0 && (
                        <span className="TaskCard__icon-indicator TaskCard__icon-indicator--attachments" title={`${task.attachments_count} attachment${task.attachments_count !== 1 ? 's' : ''}`}>
                            <i className="fas fa-paperclip" />
                            <span className="TaskCard__icon-indicator-count">{task.attachments_count}</span>
                        </span>
                    )}
                    {priority && (
                        <span className={`TaskCard__priority TaskCard__priority--${priority.className}`}>
                            {priority.label}
                        </span>
                    )}
                    {task.due_date && (
                        <span className={`TaskCard__due ${isOverdue ? 'TaskCard__due--overdue' : ''}`}>
                            {formatDueDate(task.due_date)}
                        </span>
                    )}
                    {task.assignee_info && (
                        <span className="TaskCard__assignee" title={task.assignee_info.name || task.assignee_info.email}>
                            {(task.assignee_info.name || task.assignee_info.email || '?')
                                .split(' ')
                                .slice(0, 2)
                                .map(w => w[0])
                                .join('')
                                .toUpperCase()}
                        </span>
                    )}
                </div>
            )}
        </div>
    );
};

export default TaskCard;
